exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone {\n    background: white !important;\n    border: 2px dashed #48285e  !important;\n    border-radius: 20px !important;\n    cursor: pointer !important;\n}\n.dropzone-message-wrapper {\n    color: #a5a9b1 !important;\n}\n.dropzone-start-message {\n    font-size: 54px !important;\n}\n", ""]);

// exports
